import axiosInstance from './axiosInstance';
import { API_ENDPOINTS } from '../config/api';
import { ApiResponse, AuthResponse, User } from '../types';

const authService = {
  // Sign in
  signIn: async (email: string, password: string): Promise<AuthResponse> => {
    const response = await axiosInstance.post<ApiResponse<AuthResponse>>(
      API_ENDPOINTS.AUTH.SIGNIN,
      {
        username: email,
        password,
      }
    );

    if (response.data.data.access_token) {
      localStorage.setItem('authToken', response.data.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.data.user));
    }

    return response.data.data;
  },

  // Sign out
  signOut: async (): Promise<void> => {
    await axiosInstance.post(API_ENDPOINTS.AUTH.SIGNOUT);
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
  },

  // Sign out from all devices
  signOutAll: async (): Promise<void> => {
    await axiosInstance.post(API_ENDPOINTS.AUTH.SIGNOUT_ALL);
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
  },

  // Get current user profile
  getProfile: async (): Promise<User> => {
    const response = await axiosInstance.get<User>(API_ENDPOINTS.AUTH.PROFILE);
    return response.data;
  },

  // Update FCM token
  updateFcmToken: async (fcmToken: string): Promise<void> => {
    await axiosInstance.patch('/user/update-fcm-token', {
      fcm_token: fcmToken,
    });
  },

  // Check if user is authenticated
  isAuthenticated: (): boolean => {
    return !!localStorage.getItem('authToken');
  },

  // Get current user from storage
  getCurrentUser: (): User | null => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },
};

export default authService;
